import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { getData, postData, putData } from "../../api/method";
import ModalAdd from "../../components/admin/Customer/add";
import ModalDelete from "../../components/admin/ModalConfirm";
import ModalEdit from "../../components/admin/Customer/edit";
import TableCustomers from "../../components/admin/Customer/table";

function Customers(args) {
  const phoneRegExp = /(84|0[3|5|7|8|9])+([0-9]{8})\b/;
  const emailRegExp =
    /^[a-z][a-z0-9_\.]{5,32}@[a-z0-9]{2,}(\.[a-z0-9]{2,4}){1,2}$/;
  const nameRegExp = /^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$/;
  const passwordRegExp = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
  const usernameRegExp = /^[a-z0-9_-]{3,16}$/;

  const today = new Date(),
    getDate =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    phone: "",
    email: "",
    username: "",
    password: "",
    confirmPassword: "",
    admin: 1,
    created: getDate,
    actived: 1,
  });

  const onChangeValue = (e) => {
    const { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };

  const [error, setError] = useState({});

  const [openAdd, setOpenAdd] = useState(false);

  const toggleAdd = () => setOpenAdd(!openAdd);

  const closeBtnAdd = (
    <button className="close" onClick={toggleAdd}>
      &times;
    </button>
  );

  const [openEdit, setOpenEdit] = useState(false);

  const toggleEdit = () => setOpenEdit(!openEdit);

  const closeBtnEdit = (
    <button className="close" onClick={toggleEdit}>
      &times;
    </button>
  );

  const [openDel, setOpenDel] = useState(false);

  const toggleDel = () => setOpenDel(!openDel);

  const closeBtnDel = (
    <button className="close" onClick={toggleDel}>
      &times;
    </button>
  );

  const validation = (e) => {
    const msg = {};

    if (data.firstname === "") {
      msg.firstname = "First name is requied!";
    } else if (!data.firstname.match(nameRegExp)) {
      msg.firstname = "First name is valid. Not number!";
    }

    if (data.lastname === "") {
      msg.lastname = "Last name is requied!";
    } else if (!data.lastname.match(nameRegExp)) {
      msg.lastname = "Last name is valid. Not number!";
    }

    if (data.phone === "") {
      msg.phone = "Phone is requied!";
    } else if (!data.phone.match(phoneRegExp)) {
      msg.phone = "Phone is valid. Start 84-03-05-07-08-06-09!";
    }

    if (data.email === "") {
      msg.email = "Email is requied!";
    } else if (!data.email.match(emailRegExp)) {
      msg.email = "Email is valid!";
    }

    if (data.username === "") {
      msg.username = "Username is requied!";
    } else if (!data.username.match(usernameRegExp)) {
      msg.username =
        "Username is valid. Username should be at least 3 charcters long!";
    }

    if (data.password === "") {
      msg.password = "Password is requied!";
    } else if (!data.password.match(passwordRegExp)) {
      msg.password =
        "Password should be at least 6 charcters long, at least one letter and one number!";
    }

    if (data.confirmPassword === "") {
      msg.confirmPassword = "Confirm Password is requied!";
    } else if (!data.confirmPassword.match(passwordRegExp)) {
      msg.confirmPassword =
        "Password should be at least 6 charcters long, at least one letter and one number!";
    } else if (data.confirmPassword !== data.password) {
      msg.confirmPassword = "Password does not match!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUp = () => {
    validation();
  };

  const validationEdit = (e) => {
    const msg = {};

    if (data.firstname === "") {
      msg.firstname = "First name is requied!";
    } else if (!data.firstname.match(nameRegExp)) {
      msg.firstname = "First name is valid. Not number!";
    }

    if (data.lastname === "") {
      msg.lastname = "Last name is requied!";
    } else if (!data.lastname.match(nameRegExp)) {
      msg.lastname = "Last name is valid. Not number!";
    }

    if (data.phone === "") {
      msg.phone = "Phone is requied!";
    } else if (!data.phone.match(phoneRegExp)) {
      msg.phone = "Phone is valid. Start 84-03-05-07-08-06-09!";
    }

    if (data.email === "") {
      msg.email = "Email is requied!";
    } else if (!data.email.match(emailRegExp)) {
      msg.email = "Email is valid!";
    }

    setError(msg);
    if (Object.keys(msg).length > 0) return false;
    return true;
  };

  const handleKeyUpEdit = () => {
    validationEdit();
  };

  const handleSubmitAdd = async () => {
    const isValid = validation();
    const formData = new FormData();

    if (isValid) {
      formData.append("username", data.username);
      formData.append("password", data.password);
      formData.append("firstname", data.firstname);
      formData.append("lastname", data.lastname);
      formData.append("phone", data.phone);
      formData.append("email", data.email);
      formData.append("admin", 1);
      formData.append("created", data.created);
      formData.append("actived", 1);

      try {
        const res = await postData("/api/Register", formData);
        if (res.status === 200) {
          setOpenAdd(false);
          toast.success("Register success!");
        }
      } catch (err) {
        console.log(err);
        toast.error("Register fail!");
      }
    }
  };

  const [dataDel, setDataDel] = useState([]);

  const getCustomerByDel = async (username) => {
    try {
      const result = await getData(`/api/User/${username}`);
      setDataDel(result.data);
      setOpenDel(true);
    } catch (error) {
      console.log(error);
    }
  };

  const [dataEdit, setDataEdit] = useState([]);

  const getCustomerByEdit = async (username) => {
    try {
      const result = await getData(`/api/User/${username}`);
      setDataEdit(result.data);
      setData(result.data);
      setOpenEdit(true);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmitEdit = async (username) => {
    const isValid = validationEdit();
    const editData = new FormData();

    if (isValid) {
      editData.append("username", username);
      editData.append("lastname", data.lastname);
      editData.append("firstname", data.firstname);
      editData.append("email", data.email);
      editData.append("phone", data.phone);

      try {
        const res = await putData(`/api/User/${username}`, editData);
        if (res.status === 200) {
          setOpenEdit(false);
          toast.success("Edit success!");
        }
      } catch (error) {
        console.log(error);
        setOpenEdit(false);
        toast.error("Edit fail!");
      }
    }
  };

  return (
    <div className="w-100 pt-4 px-5 py-5">
      <TableCustomers
        toggleAdd={toggleAdd}
        getCustomerByDel={(id) => getCustomerByDel(id)}
        getCustomerByEdit={(id) => getCustomerByEdit(id)}
      />

      <ModalAdd
        isOpen={openAdd}
        toggle={toggleAdd}
        close={closeBtnAdd}
        onChange={onChangeValue}
        onKeyUp={handleKeyUp}
        onClick={() => handleSubmitAdd()}
        error={error}
      />

      <ModalEdit
        isOpen={openEdit}
        toggle={toggleEdit}
        close={closeBtnEdit}
        onChange={onChangeValue}
        onKeyUp={handleKeyUpEdit}
        onClick={() => handleSubmitEdit(dataEdit.username)}
        error={error}
        dataEdit={dataEdit}
      />

      <ModalDelete
        title="Delete"
        text="Are you sure you want to delete the account?"
        toggle={toggleDel}
        close={closeBtnDel}
        isOpen={openDel}
        // onClick={() => handleSubmitDel(dataDel.id)}
      />
    </div>
  );
}

export default Customers;
